import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { afterItems, beforeItems, painPoints } from "../../data/content";
export function BeforeAfter() {
  return <section className="w-full bg-cream px-5 py-16 md:py-24" data-id="element-101" data-mp="26k04imtveq2k">
      <div className="mx-auto max-w-3xl" data-id="element-102" data-mp="22m2ddegjhtwj">
        <SectionHeading eyebrow="Let me ask you something…" title="Have you ever had an idea for an amazing aromatic product… but had no idea where to start?" data-id="element-103" data-mp="2zb1p53gc1dth" />
        <ul className="mt-8 space-y-3" data-id="element-104" data-mp="2ua48ivaz0ru3">
          {painPoints.map(p => <li key={p} className="rounded-xl bg-paper px-5 py-4 text-[17px] leading-relaxed text-ink/85 md:text-lg" data-id="element-105" data-mp="2q8si4nk9w2ku">
              {p}
            </li>)}
        </ul>
        <p className="mt-8 text-center font-serif text-2xl font-bold text-brand-olive md:text-3xl" data-id="element-106" data-mp="1ew81az41o9dc">
          If any of that sounds familiar… I created this for you.
        </p>
      </div>

      <div className="mx-auto mt-12 grid max-w-5xl gap-5 md:grid-cols-2 md:gap-6" data-id="element-107" data-mp="1754744hc8w4p">
        <div className="rounded-3xl border border-brand-rose/20 bg-brand-blush p-6 md:p-8" data-id="element-108" data-mp="1c4z1ii0bo3ui">
          <p className="text-[13px] font-bold uppercase tracking-widest text-brand-rose" data-id="element-109" data-mp="y4xxwusoaibc">Before</p>
          <h3 className="mt-1 font-serif text-2xl font-bold text-ink md:text-3xl" data-id="element-110" data-mp="133iqq95lhzpr">Before The Aroma Lab</h3>
          <ul className="mt-6 space-y-4" data-id="element-111" data-mp="oecril6rc9hv">
            {beforeItems.map(item => <li key={item} className="flex gap-3 text-[16px] leading-snug text-ink/85 md:text-[17px]" data-id="element-112" data-mp="t5bbpvuv9rqe">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-rose text-white" data-id="element-113" data-mp="feg74vrehwsm">
                  <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-114" data-mp="jgl2byxhz1hd" />
                </span>
                {item}
              </li>)}
          </ul>
        </div>

        <div className="rounded-3xl border border-brand-sage/30 bg-brand-mist p-6 md:p-8" data-id="element-115" data-mp="afmvz9zl6hvm">
          <p className="text-[13px] font-bold uppercase tracking-widest text-brand-cta" data-id="element-116" data-mp="2c40wqt05js76">After</p>
          <h3 className="mt-1 font-serif text-2xl font-bold text-ink md:text-3xl" data-id="element-117" data-mp="27dstgt12kxsb">With The Aroma Lab™</h3>
          <p className="mt-2 text-[15px] text-ink/70" data-id="element-118" data-mp="23bfpoa5vv9y6">You'll learn how to:</p>
          <ul className="mt-5 space-y-4" data-id="element-119" data-mp="1ycuoo8it4m8o">
            {afterItems.map(item => <li key={item} className="flex gap-3 text-[16px] leading-snug text-ink/90 md:text-[17px]" data-id="element-120" data-mp="1yarqv2bexote">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-cta text-white" data-id="element-121" data-mp="2v0snfni0x9l9">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-122" data-mp="2m1xei3nlhle9" />
                </span>
                {item}
              </li>)}
          </ul>
        </div>
      </div>

      <div className="mx-auto mt-12 max-w-3xl text-center" data-id="element-123" data-mp="1an0ddve4z5qj">
        <p className="text-[17px] leading-relaxed text-ink/80 md:text-lg" data-id="element-124" data-mp="1aol7jjwjgmnv">
          It's not because you're not creative. You probably have plenty of creativity. What you may be missing is a{" "}
          <strong data-id="element-125" data-mp="vm3bqegxjmct">repeatable system</strong> for turning that creativity into actual products. And most importantly…
          you'll be able to look at one of your creations and say:
        </p>
        <p className="mt-5 font-serif text-4xl font-extrabold italic text-brand-lavender md:text-5xl" data-id="element-126" data-mp="15gvavmq5uh9p">
          “I created this.”
        </p>
        <div className="mt-10" data-id="element-127" data-mp="1eb05mh8f0cui">
          <CtaButton label="I Want to Learn the System" data-id="element-128" data-mp="1e9q5znlwywlr" />
        </div>
      </div>
    </section>;
}